import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentTicket: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 1v5a2 2 0 1 1 0 4v5h16v-5a2 2 0 1 1 0-4V1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentTicket
